
<!--https://tecknowlogy.ca/chat/login/login.html?username=jibran&password=ahsan-->
<iframe id="IFrame" [src]="iframeSrc" width="600" top="100"  allow="camera;microphone"></iframe>
<!--<iframe id="widget" src="https://ciotchat.dart-it.com/ilogin/?username=jahsan&password=8x8uk0xnqb60Pv6l0kBwnsqTd585ZDVmZTFjNjA5" width="600" top="100"  allow="camera;microphone"></iframe>-->
<script type="application/javascript">

    function resizeIFrameToFitContent( iFrame ) {
    
        iFrame.width  = iFrame.contentWindow.document.body.scrollWidth;
        iFrame.height = iFrame.contentWindow.document.body.scrollHeight; 
    }
    
    window.addEventListener('DOMContentLoaded', function(e) {
    
        var iFrame = document.getElementById( 'iFrame1' );
        resizeIFrameToFitContent( iFrame );
    
        // or, to resize all iframes:
        var iframes = document.querySelectorAll("iframe");
        for( var i = 0; i < iframes.length; i++) {
            resizeIFrameToFitContent( iframes[i] );
        }
    } );
    
    
    var childWindow = document.getElementById("IFrame");
childWindow = frame ? frame.contentWindow : null;
window.addEventListener("message", (e) => {
var data= e.data; // hare are data sent by other window postMessage method
console.log(data);
});
 window.addEventListener('message', function(event) {
  //console.log(event);
  var i =event.data
  const myJSON = JSON.stringify(i);
  var j = JSON.parse(myJSON);
  //var totalunread = j
  console.log(j.eventName);
   console.log(j);
  
  
 if(j.eventName == "unread-changed"){
      
      if(isNaN(totalunread) || totalunread == j.data){
                       console.log("No New Message");

      }
  
else{
  this.totalunread =  j.data;
               console.log("Total Unread Messages: " + totalunread );
console.log("Total Direct Messages: " + d);
console.log("Total Team Messages: " + p);
console.log("Total Channel Messages: " + c);

      p=0;
      d=0;
      c=0;
   
  }
  
  }  
console.log("Message received  from application: " + myJSON);
// Message received from parent
});
    </script>

    


